import React, { ChangeEvent } from "react";
import {
  Box,
  Typography,
  Paper,
  Card,
  styled,
  RadioGroup,
  Radio,
  TextField,
  FormControl,
  FormHelperText,
  Table,
} from "@mui/material";
import { CampaignFormSteps } from "../../../enum/campaign";
import { IWithClassName } from "../../../theme/default.theme";
import { trackingApps } from "../constants";
import { CheckBoxOutlineBlank, CheckBox } from "@mui/icons-material";
import { ICampiagnTracking } from "../../../interfaces/campaign";

interface IProps extends IWithClassName {
  activeStep: CampaignFormSteps;
  form: ICampiagnTracking;
  error: ICampiagnTracking;
  changeTextHandler: (
    label: keyof ICampiagnTracking,
  ) => (event: ChangeEvent<HTMLInputElement>) => void;
}

interface ITackingApp {
  label: string;
  icon: string;
  value: string;
}

interface IAppcell {
  app: ITackingApp;
}

const Appcell = ({ app }: IAppcell) => {
  return (
    <Box component={Card} className="app-cell">
      <Radio
        value={app.value}
        className="tracking-app-radio"
        icon={
          <Box>
            <CheckBoxOutlineBlank className="checkbox-img" />
            <img
              src={`/assets/images/${app.icon}`}
              alt={app.label}
              className="radio-button"
            />
          </Box>
        }
        checkedIcon={
          <Box>
            <CheckBox className="checkbox-img" />
            <img
              src={`/assets/images/${app.icon}`}
              alt={app.label}
              className="radio-button"
            />
          </Box>
        }
      />
    </Box>
  );
};

const Tracking = ({
  activeStep,
  className,
  form,
  error,
  changeTextHandler,
}: IProps) => {
  return (
    <>
      {activeStep === CampaignFormSteps.Tracking && (
        <Box component={Paper} className={className}>
          <Typography variant="h6">Tracking</Typography>
          <FormControl>
            <RadioGroup
              row
              className="app-container"
              value={form.partner ?? ""}
              onChange={changeTextHandler("partner")}
            >
              {trackingApps.map((app) => (
                <Appcell app={app} key={app.value} />
              ))}
            </RadioGroup>
            <FormHelperText error={!!error.partner}>
              {error.partner}
            </FormHelperText>
          </FormControl>

          <FormControl className="tracking-click-url">
            <TextField
              label="Tracking Link"
              type="url"
              error={!!error.impressionUrl}
              helperText={error.impressionUrl}
              value={form.impressionUrl ?? ""}
              onChange={changeTextHandler("impressionUrl")}
            />
            <FormHelperText>For example:https://www.example.com</FormHelperText>
          </FormControl>

          <Box>
            <Table sx={{width: "20%", margin: "20px"}}>
              <tr>
                <td colSpan={2}><strong>Events mapping:</strong></td>
              </tr>
              <tr>
                <td>Click ID</td>
                <td>{"{click_id}"}</td>
              </tr>
              <tr>
                <td>Sub Publisher ID</td>
                <td>{"{source}"}</td>
              </tr>
              <tr>
                <td>Affiliate ID</td>
                <td>{"{publisher_id}"}</td>
              </tr>
              <tr>
                <td>GAID</td>
                <td>{"{gaid}"}</td>
              </tr>
              <tr>
                <td>IDFA</td>
                <td>{"{idfa}"}</td>
              </tr>
            </Table>
          </Box>
        </Box>
      )}
    </>
  );
};

export default styled(Tracking)(({ theme }) => ({
  height: 500,
  h6: {
    fontWeight: 600,
    fontSize: 20,
    padding: theme.spacing(2),
  },
  ".app-cell": {
    width: 100,
    height: 100,
    padding: theme.spacing(0.5),
    margin: theme.spacing("auto", 0),
    display: "flex",
    alignItems: "center",
    ".radio-button": {
      width: 100,
      margin: "auto",
    },
    // "&:has(.Mui-checked)": {
    //   border: `5px solid ${theme.palette.primary.main}`,
    // },
  },
  ".app-container": {
    gap: theme.spacing(1.5),
    margin: theme.spacing(2),
  },
  ".tracking-app-radio": {
    padding: 0,
    position: "absolute",
    height: "inherit",
  },
  ".tracking-click-url": {
    margin: theme.spacing(2),
    width: "calc(100% - 32px)",
  },
  ".checkbox-img": {
    position: "absolute",
    top: 0,
    right: 0,
  },
}));
